import {Action} from '@ngrx/store';

export enum ActionTypesSpecialScenarios {
  SAVE_SPECIAL_SCENARIOS_ACTIVE = '[Special-Scenariocs] Save Special Scenarios Active',
  REMOVE_SPECIAL_SCENARIOS_ACTIVE = '[Special-Scenariocs] Remove Special Scenarios Active',
  CLEAN_ALL_SPECIAL_SCENARIOS = '[Special-Scenariocs] Clean Special scenarios Active',
}

export class SaveSpecialScenarioActive implements Action {
  readonly type = ActionTypesSpecialScenarios.SAVE_SPECIAL_SCENARIOS_ACTIVE;
  constructor(public payload: string[]) {}
}
export class RemoveSpecialScenarioActive implements Action {
  readonly type = ActionTypesSpecialScenarios.REMOVE_SPECIAL_SCENARIOS_ACTIVE;
  constructor(public payload: string) {}
}
export class CleanAllSpecialScenarios implements Action {
  readonly type = ActionTypesSpecialScenarios.CLEAN_ALL_SPECIAL_SCENARIOS;
  constructor() {}
}
export type Actions =
  | SaveSpecialScenarioActive
  | RemoveSpecialScenarioActive
  | CleanAllSpecialScenarios;
